import { useDispatch, useSelector } from 'react-redux'
import { api } from '../services/api'

const useHouseholds = () => {
	const dispatch = useDispatch()
	const households = useSelector((state) => state.specific.households.households)
	const selectedHousehold = useSelector((state) => state.specific.households.selected)
	const loading = useSelector((state) => state.specific.households.loading)

	const getHouseholdsByMarketId = async (marketId, search, searchBy, isPetSearch) => {
		if (!marketId) {
			return
		}
		dispatch({ type: 'GET_HOUSEHOLDS' })
		try {
			const response = await api.get(
				`/markets/${marketId}/clients${search ? `?text=${search}` : ''}${
					searchBy ? `&searchBy=${searchBy}` : ''
				}`
			)

			if (isPetSearch) {
				dispatch({ type: 'GET_HOUSEHOLDS_SUCCESS', payload: [] })
			} else {
				dispatch({ type: 'GET_HOUSEHOLDS_SUCCESS', payload: response.data })
			}
		} catch (e) {
			dispatch({ type: 'GET_HOUSEHOLDS_FAIL' })
		}
	}

	/**
	 * This function calls the /clients/search/advanced endpoint to search for households.
	 * It was created to allow for a more granular search that can help minimize the payload
	 * If leanPayload is false, the payload will include the household's pets, memberships, accounts, and credits and all household fields
	 *
	 * @param {{
	 * 	marketId: string,
	 * 	search: string,
	 * 	searchBy: 'contact' | 'pet_name' | 'email' | 'phone'
	 * 	leanPayload: boolean,
	 * 	includePets: boolean,
	 * 	includeMemberships: boolean,
	 * 	includeAccounts: boolean,
	 * 	includeCredits: boolean
	 *  includeTraining: boolean
	 * }} param1
	 * @param {} param1.marketId The market id of the current facility
	 * @param {} param1.search The search text - Length must be at least 3 characters
	 * @param {} param1.searchBy The field to search by
	 * @param {} param1.leanPayload If true, minimal fields are returned
	 * @param {} param1.includePets If true, the payload will include the household's pets
	 * @param {} param1.includeMemberships If true, the payload will include the household's memberships
	 * @param {} param1.includeAccounts If true, the payload will include the household's accounts
	 * @param {} param1.includeCredits If true, the payload will include the household's credits
	 * @param {} param1.includeTraining If true, the payload will include the household's training enrollments
	 * @returns
	 */
	const getHouseholdsWithAdvancedSearch = async ({
		marketId,
		search = '',
		searchBy,
		leanPayload = false,
		includePets = false,
		includeVaccines = false,
		includeMemberships = false,
		includeAccounts = false,
		includeCredits = false,
		includeTraining = false,
		isPetSearch = false
	}) => {
		if (search.length < 3) {
			return
		}

		if (!isPetSearch) dispatch({ type: 'GET_HOUSEHOLDS' })


		try {
			let url = `/clients/search/advanced?leanPayload=${leanPayload}`

			if (marketId) {
				url += `&marketId=${marketId}`
			}

			if (search) {
				url += `&text=${search}`
			}

			if (searchBy) {
				url += `&searchBy=${searchBy}`
			}

			if (includeMemberships) {
				url += `&includeMemberships=${includeMemberships}`
			}

			if (includeAccounts) {
				url += `&includeAccounts=${includeAccounts}`
			}

			if (includeVaccines) {
				url += `&includeVaccines=${includeVaccines}`
			}

			if (includePets) {
				url += `&includePets=${includePets}`
			}

			if (includeCredits) {
				url += `&includeCredits=${includeCredits}`
			}

			if (includeTraining) {
				url += `&includeTraining=${includeTraining}`
			}

			const response = await api.get(url)
			const { data, errors, messages } = response.data

			if (errors && errors.length > 0 && !isPetSearch) {
				dispatch({ type: 'GET_HOUSEHOLDS_FAIL' })
				dispatch(showError(errors[0].message))
				return
			}

			if (messages && messages.length > 0 && !isPetSearch) {
				dispatch(showSuccess(messages[0].message))
				return
			}

			if (isPetSearch) {
				console.log('its a pet search')
				dispatch({ type: 'GET_PET_SEARCH_SUCCESS', payload: [] })
				return new Promise((resolve) => resolve(data))
			} else {
				dispatch({ type: 'GET_HOUSEHOLDS_SUCCESS', payload: data })
			}
		} catch (e) {
			dispatch({ type: 'GET_HOUSEHOLDS_FAIL' })
		}
	}

	const clearHouseholds = () => {
		dispatch({ type: 'GET_HOUSEHOLDS_SUCCESS', payload: [] })
	}

	return {
		households,
		loading,
		getHouseholdsByMarketId,
		getHouseholdsWithAdvancedSearch,
		clearHouseholds
	}
}

export default useHouseholds
